/**
 * In-memory audit ring buffer for device-scoped operator actions (UI foundation).
 * Replace with backend /audit when available.
 */

export type DeviceAuditEntry = {
  id: string;
  timestamp: string;
  user_id: string | null;
  device_id: string;
  action: string;
  /** High-level diff / payload summary (JSON-serializable) */
  payload_summary: Record<string, unknown>;
};

const MAX = 400;
const entries: DeviceAuditEntry[] = [];

export function recordDeviceAudit(
  partial: Omit<DeviceAuditEntry, "id" | "timestamp"> & { timestamp?: string },
): DeviceAuditEntry {
  const row: DeviceAuditEntry = {
    id: `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
    timestamp: partial.timestamp ?? new Date().toISOString(),
    user_id: partial.user_id,
    device_id: partial.device_id,
    action: partial.action,
    payload_summary: partial.payload_summary,
  };
  entries.unshift(row);
  if (entries.length > MAX) {
    entries.length = MAX;
  }
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent("atech-device-audit", { detail: { deviceId: row.device_id } }));
  }
  return row;
}

export function getDeviceAuditLog(deviceId: string, limit = 50): DeviceAuditEntry[] {
  return entries.filter((e) => e.device_id === deviceId).slice(0, limit);
}
